export default __webpack_public_path__ + "static/media/login-page-light.8fdc3a76.png";